import { observable, runInAction } from "mobx";
import { api_adm } from "../../api";
import { toast } from "react-toastify";
import { IPautaRS, newIPautaRS } from "../../model";

export class _PautaRsStore {

  obs = observable({
    pauta: [] as any[],
    filter: "" as string,
    currentPage: 1 as number,
    length_pauta: 0 as number,
    pmpfs: [] as any[],
    filter_pmpf: "" as string,
    current_page_pmpf: 1 as number,
    length_pmpf: 0 as number,
  })

  async handlePageFilter(page: number, filter: string) {

    let data = {
      page: page,
      limit: 20,
      filter: filter,
    }

    let resp = await api_adm.post("/api/admin/pmpf/index/config", data);

    this.obs.pauta = [];
    this.obs.length_pauta = 0;

    if (resp.data.itens.length > 0) {

      this.obs.pauta = resp.data.itens
      this.obs.length_pauta = resp.data.count

    }

  }

  async handlePmpf(page: number, ano: number, ciclo: number, filter: string) {

    try {

      let data = {
        ano: ano,
        ciclo: ciclo,
        page: page,
        limit: 10,
        filter: filter
      }

      let resp = await api_adm.post(`/api/admin/pmpf/index`, data)

      this.obs.pmpfs = [];
      this.obs.length_pmpf = 0;

      if (resp.data.itens.length > 0) {

        this.obs.pmpfs = resp.data.itens
        this.obs.length_pmpf = resp.data.count

      }

    } catch (ex) { }

  }

  async handleDeletePmpf(id) {

    try {
      let resp = await api_adm.delete(`/api/admin/pmpf/${id}`);

      if (resp.data.ok) {

        toast.success('Ajuste excluído', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Não foi possível excluir ajuste, tente novamente mais tarde!", {});

    }

    return false

  }

  async handleImport(data) {

    try {

      let resp = await api_adm.post("/api/admin/pmpf/csv", data)

      if (resp.data.ok) {

        toast.success('Arquivo importado com sucesso!', {});

        return true

      }

      toast.error(resp.data.msg, {});

    } catch (ex) {

      toast.error("Não foi possível importar csv, tente novamente mais tarde!", {});

    }

    return false

  }

  async doSaveCreateAjuste(data) {

    try {

      let resp = await api_adm.post("/api/admin//pmpf/config", data)

      if (resp.data.ok) {

        toast.success('Ajuste criado com sucesso!', {});

        return true

      }

      toast.error(resp.data.msg, {});

    } catch (ex) {

      toast.error("Não foi possível criar ajuste, tente novamente mais tarde!", {});

    }

    return false

  }

}

export const PautaRsStore = new _PautaRsStore();
